import { IMaster } from '../IMaster';

import {
  CPSConfig,
  CPSConfigFunctionnality,
  HistoryChartModeEnum,
  HistoryGraphModeEnum,
  HistoryGraphYModeEnum,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';

import { P00039 } from './P00039';
import { P00032 } from './P00032';
import { P00039DataRxTxIndex } from './P00039Sync';
import { Pool } from '../../../../apis/pool.api';
import { P00037InstallationFinish } from './P00037/Installation/P00037InstallationFinish';
import { P00037InstallationReset } from './P00037/Installation/P00037InstallationReset';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P00037ElectrolyseurMiseEnOeuvreInit } from './P00037/Electrolyseur/miseenoeuvre/P00037ElectrolyseurMiseEnOeuvreInit';
import { P00037InstallationCelluleComponent } from './P00037/Installation/p00037-installation-cellule/p00037-installation-cellule.component';
import { P00037InstallationCelluleQRCodeComponent } from './P00037/Installation/p00037-installation-cellule-qrcode/p00037-installation-cellule-qrcode.component';
import { P00037CardElectrolyseurStatutComponent } from './P00037/Electrolyseur/cards/p00037-card-electrolyseur-statut/p00037-card-electrolyseur-statut.component';
import { P00037CardElectrolyseurControleComponent } from './P00037/Electrolyseur/cards/p00037-card-electrolyseur-controle/p00037-card-electrolyseur-controle.component';
import { P00037Alarm } from './P00037/Alarm/P00037Alarm';
import { P00037ElectrolyseurMiseEnOeuvreDesinfectionComponent } from './P00037/Electrolyseur/miseenoeuvre/p00037-electrolyseur-mise-en-oeuvre-desinfection/p00037-electrolyseur-mise-en-oeuvre-desinfection.component';
import { P00037ElectrolyseurMiseEnOeuvreProtectionComponent } from './P00037/Electrolyseur/miseenoeuvre/p00037-electrolyseur-mise-en-oeuvre-protection/p00037-electrolyseur-mise-en-oeuvre-protection.component';
import { P00037ElectrolyseurControleComponent } from './P00037/Electrolyseur/cps/p00037-electrolyseur-controle/p00037-electrolyseur-controle.component';
import { P00037ElectrolyseurParametersComponent } from './P00037/Electrolyseur/cps/p00037-electrolyseur-parameters/p00037-electrolyseur-parameters.component';
import { P00037ElectrolyseurStatutComponent } from './P00037/Electrolyseur/cps/p00037-electrolyseur-statut/p00037-electrolyseur-statut.component';
import { P00037FunctionHistoryGraphComponentComponent } from './P00037/Component/p00037-function-history-graph-component/p00037-function-history-graph-component.component';

export class P00037Data {
  elCModeFonctionnement: number = 0;
  elCResetUsine: number = 0;
  elCResetNiveauSel: number = 0;
  elConfirmationOTA: number = 0;
  elCResetProtectionPresenceGaz: number = 0;

  elPConsigneManuel: number = 0;
  elPHysteresisRegulationRX: number = 0;
  elPConsigneRX: number = 0;
  elPTypeHorloge: number = 0;
  elPActivationSecuriteDesinfection: number = 0;
  elPActivationHivernage: number = 0;
  elPTauxAbaissementVolet: number = 0;
  elPTemperatureHivernage: number = 0;
  elPDureeInversionPolarite: number = 0;

  elPHorlogeLundi: string = '000000000000000000000000000000000000000000000000';
  elPHorlogeMardi: string = '000000000000000000000000000000000000000000000000';
  elPHorlogeMercredi: string =
    '000000000000000000000000000000000000000000000000';
  elPHorlogeJeudi: string = '000000000000000000000000000000000000000000000000';
  elPHorlogeVendredi: string =
    '000000000000000000000000000000000000000000000000';
  elPHorlogeSamedi: string = '000000000000000000000000000000000000000000000000';
  elPHorlogeDimanche: string =
    '000000000000000000000000000000000000000000000000';
  elPHorlogeSemaine: string =
    '000000000000000000000000000000000000000000000000';

  elIConfigurationProduit: number = 0;
  elIActivationFonctionPrioriteElectrolyse: number = 0;
  elIActivationFonctionPrioriteAutoMaintien: number = 0;
  elIActivationFonctionPrioriteBoost: number = 0;
  elISondeReferenceRX: number = 0;
  elISourceReferenceFonctionVolet: number = 0;
  elICapteurTemperatureReferenceFonctionProtectionHivernage: number = 0;
  elISourceReferenceDebitFonctionProtectionDebit: number = 0;
  elICaracteristiqueCelluleQRImax: number = 0;
  elICaracteristiqueCelluleQRUmax: number = 0;
  elICaracteristiqueCelluleQRVt: number = 0;

  elSProtectionThermique: number = 0;
  elSEtatInverseurPolarite: number = 0;
  elSEtatAlimentation: number = 0;
  elSEtatProduction: number = 0;
  elSDisponibiliteSondeRX: number = 0;
  elSEtatVolet: number = 0;
  elSDisponibiliteVolet: number = 0;
  elSAbaissementVolet: number = 0;
  elSMesureDebit: number = 0;
  elSDisponibiliteDebit: number = 0;
  elSSecuriteDesinfection: number = 0;
  elSProtectionHivernage: number = 0;
  elSDisponibiliteTemperatureEau: number = 0;
  elSProtectionPresenceGaz: number = 0;
  elSEtatLimiteurPuissance: number = 0;
  elSCaracteristiqueCelluleUtilise: number = 0;
  elSMiseEnRouteFiltrationPriorite: number = 0;
  elSMiseEnRouteFiltrationAutoMaintien: number = 0;
  elSSecuriteDeconnexionProduit: number = 0;
  elSAlarme: number = 0;
  elSDefautCourant: number = 0;
  elSResultatTestUsureCellule: number = 0;
  elSEtatTemperature: number = 0;
  elSEtatGPIOExtendeur: number = 0;
  elSMemoire: number = 0;
  elSMiseEnRouteFiltrationPrioriteBoost: number = 0;
  elSNiveauSelBas: number = 0;
  elSConsigneProduction: number = 0;
  elSConsigneApplique: number = 0;
  elSConsigneInversion: number = 0;
  elSConsigneCommandeAlim: number = 0;
  elSConsigneCourant: number = 0;
  elSConsigneMesureCellule: number = 0;
  elSTensionMesureCellule: number = 0;
  elSTemperatureProduit: number = 0;
  elSMesureRX: number = 0;
  elSTempsRestantBoost: number = 0;
  elSDureeDebitMaintenu: number = 0;
  elSMesureTemperatureEau: number = 0;
  elSTempsRestantEtapePolariteCourant: number = 0;
  elSCaracteristiqueCelluleImax: number = 0;
  elSCaracteristiqueCelluleUmax: number = 0;
  elSCaracteristiqueCelluleVt: number = 0;
  elSCumulTempsFonctionnementTemperatureBasse: number = 0;

  elSDureeProduction25: number = 0;
  elSDureeProduction50: number = 0;
  elSDureeProduction75: number = 0;
  elSDureeProduction100: number = 0;
  elSPuissanceActive: number = 0;
  elSCompteurPuissanceActiveTotale: number = 0;
  elSTransferChargeCellule: number = 0;
  elSNombreInversionPolarite: number = 0;
  elSEtatBouton: number = 0;
  elSPolariteProduction: number = 0;
  elSCompteurBouton: number = 0;
  elSCompteurResetUsine: number = 0;
}

export class P00037 extends IProduct {
  override deviceTableIndex: number = 10;

  override modelIdentifier?: string = 'P00037-00';

  override dataIdentifier?: string = 'P0003700';

  override manufacturerName?: string = 'ACWA';

  data: P00037Data = new P00037Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P00037/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P00037/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P00037/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P0003700;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P0003700?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P00037.tuto.installation.help.title',
      helpSlides: [
        'P00037.tuto.installation.help.1',
        'P00037.tuto.installation.help.2',
        'P00037.tuto.installation.help.3',
        'P00037.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00037/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00037/installation-1_dark.png',
          },
          text: 'P00037.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00037/installation-2.png',
            dark: '/assets/ecosystem/images/products/P00037/installation-2_dark.png',
          },
          text: 'P00037.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P00037/installation-1.png',
            dark: '/assets/ecosystem/images/products/P00037/installation-1_dark.png',
          },
          text: 'P00037.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P00037/update-2.png',
            dark: '/assets/ecosystem/images/products/P00037/update-2_dark.png',
          },
          text: 'P00037.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          {
            component: P00037InstallationCelluleComponent,
            condition: () => {
              return true;
            },
          },
          {
            component: P00037InstallationCelluleQRCodeComponent,
            condition: (pool: Pool) => {
              return (
                pool.deviceTable.P0003700.data
                  .elSCaracteristiqueCelluleUtilise == 0
              );
            },
          },
        ],
        finish: P00037InstallationFinish,
        reset: P00037InstallationReset,
      },

      statusCards: [
        { component: P00037CardElectrolyseurStatutComponent, weight: 16 },
      ],

      controlCards: [
        { component: P00037CardElectrolyseurControleComponent, weight: 15 },
      ],

      alarms: {
        component: P00037Alarm,
        weight: 19,
      },

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.DISINFECTION];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality | EventProductFunctionnalityEnum,
  ): CPSConfigFunctionnality | null {
    if (
      functionnality == IProductFunctionnality.ELECTROLYSEUR_SALT ||
      functionnality == EventProductFunctionnalityEnum.DISINFECTION
    ) {
      return {
        miseEnOeuvre: {
          pages: [
            {
              component: P00037ElectrolyseurMiseEnOeuvreDesinfectionComponent,
              condition: () => {
                return true;
              },
            },
            {
              component: P00037ElectrolyseurMiseEnOeuvreProtectionComponent,
              condition: (pool: Pool) => {
                return (
                  new P00039().hasProduct(pool, new P00032()) > 0 &&
                  pool.deviceTable.P0003700.data
                    .elICapteurTemperatureReferenceFonctionProtectionHivernage ==
                    1
                );
              },
            },
          ],
          init: P00037ElectrolyseurMiseEnOeuvreInit,
        },
        controle: {
          enabledUser: true,
          enabledSupport: true,
          component: P00037ElectrolyseurControleComponent,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,

          reglage: {
            enabledUser: true,
            enabledSupport: true,
            component: P00037ElectrolyseurParametersComponent,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          component: P00037ElectrolyseurStatutComponent,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            graphiques: [
              {
                title: 'P00037.history.fonctionnement',
                mode: HistoryGraphModeEnum.EVENT,
                codeEvent: 180,
                yMode: HistoryGraphYModeEnum.HOUR,
                property: 'elSEtatProduction',
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
              },
              {
                title: 'P00037.history.puissance',
                mode: HistoryGraphModeEnum.DATA,
                property: 'elSCompteurPuissanceActiveTotale',
                aggregate: 'delta',
                yMode: HistoryGraphYModeEnum.WATT,
                yModeOptions: { min: 0, max: 150 },
                chartMode: HistoryChartModeEnum.NORMAL,
                enabledTotal: true,
              },
              {
                title: 'P00037.history.rx',
                mode: HistoryGraphModeEnum.DATA,
                property: 'elSMesureRX',
                aggregate: 'avg',
                yMode: HistoryGraphYModeEnum.MVOLT,
                yModeOptions: { min: 0, max: 1000 },
                chartMode: HistoryChartModeEnum.LINEAR,
              },
              {
                title: 'P00037.history.dureeproduction',
                mode: HistoryGraphModeEnum.DATA,

                customGraph: {
                  axesX: ['25%', '50%', '75%', '100%'],
                  properties: [
                    'elSDureeProduction25',
                    'elSDureeProduction50',
                    'elSDureeProduction75',
                    'elSDureeProduction100',
                  ],
                },
                customGraphComponent:
                  P00037FunctionHistoryGraphComponentComponent,
                aggregate: 'delta',
                yMode: HistoryGraphYModeEnum.HOUR,
                enabledTotal: true,
              },
            ],
          },
        },
      };
    }
    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.SALT_Controle,
      propertyName: 'elConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 1;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).elIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_1.csv'
    );
  }
}
